/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Stack, TextField, Typography } from '@mui/material';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { fundUsersWallet } from '../../../api/users.api';

export default function UserOptionsCardFund({ user, handleRefresh, type, onSuccess }) {
  // state

  const [amount, setAmount] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState(false);
  const [statusMessage, setStatusMessage] = React.useState();
  const [valid, setValid] = React.useState(false);
  const [show, setShow] = React.useState(false);

  const [isLoading, setIsLoading] = React.useState(false);
  const [reference, setReference] = React.useState('');
  const [pin, setPin] = React.useState('');
  const [fakePin, setFakingPin] = React.useState('');
  const [resolution, setResolution] = useState(false);
  const [ticketRef, setTicketRef] = useState('');

  const handleUserWallet = async () => {
    setShow(true);
    setLoading(true);

    const response = await fundUsersWallet(user?.user?.id, {
      amount,
      reference,
      type: 'fund',
    });

    // agent, from, amount, reference,
    if (response.ok && response.data?.success) {
      setLoading(false);
      setStatus(true);
      handleRefresh();
      setStatusMessage(response.data.message);
      return;
    }
    setLoading(false);
    setStatus(false);

    setStatusMessage(response.data.message);
  };

  const handleToggleShow = () => {

    if (status) {
      onSuccess();
      return;
    }

    setShow(false);
  };

  React.useEffect(() => {
    if (amount !== '' && reference) {
      setValid(true);
      return;
    }

    setValid(false);
  }, [amount, reference]);

  return (
    <>
      <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
        {isLoading ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'white',
              zIndex: 7,
            }}
          >
            <CircularProgress />
            <Typography>Please wait...</Typography>
          </Box>
        ) : (
          <>
            {show && (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'white',
                  zIndex: 7,
                }}
              >
                {loading ? (
                  <CircularProgress />
                ) : (
                  <>
                    <Typography textAlign={'center'}>{statusMessage}</Typography>

                    <Button variant="outlined" onClick={handleToggleShow}>
                      Ok
                    </Button>
                  </>
                )}
              </Box>
            )}

            <Stack>
              <Typography variant={'h4'}>{type} Wallet</Typography>
              <Typography mt={1} variant="p" color={'GrayText'}>
                To {type} please fill in the form below and Submit
              </Typography>

              <TextField
                sx={{ mt: 4 }}
                id="outlined-required"
                autoComplete="off"
                label="Amount"
                value={amount}
                onChange={(event) => {
                  if (Number(event.target.value) || event.target.value === '') {
                    setAmount(event.target.value);
                  }
                }}
              />
              <TextField
                sx={{ my: '20px' }}
                label="Reference"
                inputProps={{
                  autoComplete: 'new-password',
                }}
                value={reference}
                autoComplete="chrome-off"
                onChange={(event) => setReference(event.target.value)}
              />

              {/* <TextField
                sx={{ my: '20px' }}
                label="Your PIN"
                value={fakePin}
                type="text"
                autoComplete="off"
                onChange={(event) => {
                  if (event.target.value.length < pin.length) {
                    // remove last character
                    setPin(pin.slice(0, -1));
                  } else {
                    setPin(pin + event.target.value[event.target.value.length - 1]);
                  }
                  setFakingPin(event.target.value.replace(/./g, '*'));
                }}
              /> */}
            </Stack>

            <Stack direction={'row'} sx={{ mt: '20px' }}>
              <Button fullWidth variant={'outlined'} onClick={onSuccess} sx={{ mr: '10px' }}>
                Cancel
              </Button>
              <Button variant={'contained'} onClick={handleUserWallet} disabled={!valid} fullWidth>
                Submit
              </Button>
            </Stack>
          </>
        )}
      </Box>
    </>
  );
}
